module.exports = __webpack_public_path__ + "img/帐篷.fc5201a8.svg";